import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=205d04a0&scoped=true&"
import script from "./Layouts.vue?vue&type=script&lang=js&"
export * from "./Layouts.vue?vue&type=script&lang=js&"
import style1 from "./Layouts.vue?vue&type=style&index=1&id=205d04a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d04a0",
  null
  
)

export default component.exports